module.exports = __webpack_public_path__ + "static/media/4.c386be64.png";